import toastErrors from './toast-errors'

export const errorCodeToastMap = {
  'FLEET_TASK.FLEET_TASK_CANNOT_UNASSIGN_TRANSIT_DELIVERY_ORDER':
    toastErrors['fleet-task-cannot-unassign-transit-delivery-order'],
  'FLEET_TASK.FLEET_TASK_DELIVERY_ORDER_SHIPMENT_TYPE_TRANSIT':
    toastErrors['fleet-task-delivery-order-shipment-type-transit'],
  'FLEET_TASK.FLEET_TASK_DELIVERY_ORDER_COMPLETED_TRANSIT':
    toastErrors['fleet-task-delivery-order-completed-transit'],
  'FLEET_TASK.FLEET_TASK_LAST_AND_NEW_TRANSIT_ARE_IDENTICAL':
    toastErrors['fleet-task-last-and-new-transit-are-identical'],
  'FLEET_TASK.FLEET_TASK_TRANSIT_ADDRESS_ARE_IDENTICAL':
    toastErrors['fleet-task-transit-address-are-identical'],
  'FLEET_TASK.FLEET_TASK_DELIVERY_ORDER_ORIGIN_DIFFERENT_WITH_LAST_TRANSIT':
    toastErrors['fleet-task-delivery-order-origin-different-with-last-transit'],
  'FLEET_TASK.DELIVERY_ORDER_VENDOR_REQUEST_INVALID_SHIPMENT_TYPE':
    toastErrors['delivery-order-vendor-request-invalid-shipment-type'],
  'FLEET_TASK.DELIVERY_ORDER_VENDOR_EXISTS': toastErrors['delivery-order-vendor-exists'],
  'FLEET_TASK.FLEET_TASK_PREVIOUS_ACTIVITY_NOT_COMPLETED':
    toastErrors['fleet-task-previous-activity-not-completed'],
  'FLEET_TASK.USER_GROUP_ONLY_ONE_GROUP_CAN_BE_SELECTED':
    toastErrors['user-group-only-one-group-can-be-selected'],
  'FLEET_TASK.FLEET_TASK.DELIVERY_ORDER_USER_GROUP_ID.DIFFERENT':
    toastErrors['fleet-task-delivery-order-user-group-id-different'],
  'FLEET_TASK.FLEET_TASK.DELIVERY_ORDER_USER_GROUP_ID.REQUIRED':
    toastErrors['fleet-task-delivery-order-user-group-id-required'],
  'FLEET_TASK.DELIVERY_ORDER_BOX_TYPE_ID.DIFFERENT':
    toastErrors['fleet-task-delivery-order-box-type-id-different'],
  'FLEET_TASK.BOX_TYPE.NOT_FOUND': toastErrors['fleet-task-box-type-not-found'],
  'FLEET_TASK.VEHICLE_BOX_TYPE_ID.DIFFERENT': toastErrors['fleet-task-vehicle-box-type-id-different'],
  'FLEET_TASK.BOX_TYPE_NOT_FOUND': toastErrors['fleet-task-box-type-not-found'],
  'FLEET_TASK.FLEET_TASK_ACTIVITY_INVALID_STATUS': toastErrors['fleet-task-activity-invalid-status'],
}

export const errorCodeInputMap = {
  'FLEET_TASK.FLEET_TASK_SHIPMENT_REFERENCE_IS_ALREADY_USED':
    'fleetTask.inputErrors.shipmentReferenceIsAlreadyUsed',
  'FLEET_TASK.FLEET_TASK_CUSTOMER_PHONE_NUMBER_INVALID':
    'fleetTask.inputErrors.invalidCustomerPhoneNumber',
  'FLEET_TASK.FLEET_TASK_CUSTOMER_PHONE_NUMBER_IS_REQUIRED': 'global.validation.required',
  'FLEET_TASK.FLEET_TASK.DELIVERY_ORDER_USER_GROUP_ID.DIFFERENT': 'Gagal update user group',
  'FLEET_TASK.FLEET_TASK_ACTIVITY_INVALID_PICKUP_COMPLETED_ON':
    'Waktu Pengambilan tidak boleh kurang dari Waktu Keberangkatan Aktual',
  'FLEET_TASK.FLEET_TASK_ACTIVITY_PICKUP_COMPLETED_ON_CANNOT_MORE_THAN_NOW':
    'Waktu Pengambilan tidak boleh lebih dari Waktu saat ini',
  'FLEET_TASK.FLEET_TASK_ACTIVITY_INVALID_DROP_COMPLETED_ON':
    'Waktu Pengiriman tidak boleh kurang dari Waktu Pengambilan',
  'FLEET_TASK.FLEET_TASK_ACTIVITY_DROP_COMPLETED_ON_CANNOT_MORE_THAN_NOW':
    'Waktu Pengiriman tidak boleh lebih dari Waktu saat ini',
  'FLEET_TASK.VEHICLE_GROUP_INVALID': 'fleetTask.inputErrors.vehicleGroupInvalid',
  'FLEET_TASK.DRIVER_USER_GROUP_EMPTY': 'fleetTask.inputErrors.driverUserGroupInvalid',
  'FLEET_TASK.DRIVER_USER_GROUP_INVALID': 'fleetTask.inputErrors.driverUserGroupInvalid',
  'FLEET_TASK.DRIVER_USER_2_GROUP_INVALID': 'fleetTask.inputErrors.driverUserGroupInvalid',
  'FLEET_TASK.VEHICLE_STATUS_INVALID': 'Status kendaraan tidak aktif',
  'FLEET_TASK.VEHICLE_BOX_TYPE_ID.DIFFERENT': 'Jenis Box kendaraan tidak sesuai dengan muatan',
  'FLEET_TASK.FLEET_TASK_DRIVER_ALREADY_REGISTERED': 'Pengemudi Tambahan telah terpakai pada pengiriman lain',
  'FLEET_TASK.DRIVER_1_CANNOT_EQUAL_DRIVER_2': 'Pengemudi Utama tidak boleh sama dengan Pengemudi Tambahan',
  'FLEET_TASK.DRIVER_2_CANNOT_EQUAL_DRIVER_1': 'Pengemudi Tambahan tidak boleh sama dengan Pengemudi Utama',
}

export const errorCodeInputMapFindFieldKey = {
  'FLEET_TASK.FLEET_TASK_ACTIVITY_INVALID_PICKUP_COMPLETED_ON': 'completed_on',
  'FLEET_TASK.FLEET_TASK_ACTIVITY_PICKUP_COMPLETED_ON_CANNOT_MORE_THAN_NOW': 'completed_on',
  'FLEET_TASK.FLEET_TASK_ACTIVITY_INVALID_DROP_COMPLETED_ON': 'completed_on',
  'FLEET_TASK.FLEET_TASK_ACTIVITY_DROP_COMPLETED_ON_CANNOT_MORE_THAN_NOW': 'completed_on',
}

export const errorCodeCheckedMap = {
  'FLEET_TASK.BOX_TYPE_NOT_FOUND': {
    checked: true,
    message: 'Jenis Box tidak ditemukan.',
  }
}
